import { Service } from '../Service';
import { ClippingBoxTool } from './Tool';
/**
 * API for clipping a dynamic model.
 */
export class ClippingService extends Service {
    constructor(modules, navigationService) {
        super(modules);
        Object.defineProperty(this, "navigationService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.navigationService = navigationService;
    }
    /**
     * Create a clipping box tool to apply on a set of dynamic models.
     */
    createBoxTool() {
        return new ClippingBoxTool(this.renderer, this.widgetManager, this.navigationService);
    }
    updateFrame(deltaTime) { }
}
